import { apiSlice } from "./apiSlice";

export const mileageApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 마일리지 충전 요청
        chargeMileage: build.mutation({
            query: (body) => ({
                url: "/api/user/mileage/v1/charge/request",
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        // 마일리지 출금 요청
        withdrawMileage: build.mutation({
            query: (body) => ({
                url: "/api/user/mileage/v1/withdraw/request",
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        // 마일리지 현황 조회
        getMileageStatus: build.query({
            query: () => ({
                url: "/api/user/mileage/v1",
                method: "get",
                headers: { token: true },
            }),
        }),
        // 사용가능 마일리지 조회
        getUsableMileage: build.query({
            query: () => ({
                url: "/api/user/mileage/v1/usable",
                method: "get",
                headers: { token: true },
            }),
        }),
        // 마일리지 이용내역 리스트 조회
        getMileageHistory: build.query({
            query: (params) => ({
                url: "/api/user/mileage/v1/history",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),
        // 포인트 이용내역 리스트 조회
        getPointHistory: build.query({
            query: (params) => ({
                url: "/api/user/point/v1/history",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useChargeMileageMutation,
    useWithdrawMileageMutation,
    useGetMileageStatusQuery,
    useGetUsableMileageQuery,
    useGetMileageHistoryQuery,
    useGetPointHistoryQuery,
} = mileageApi;
